import { usePickedWinnerUserData } from "./hooks/usePickedWinnerUserData";
import { PickerWinnerPopupUI } from "./picker-winner-popup.ui";
import React from "react";
import "./styles/_pickerWinners.styles.scss";

export const PickerWinnerPopupFetcher = () => {
  const { data } = usePickedWinnerUserData();

  console.log(data);

  if (!data) {
    return;
  }

  return <PickerWinnerPopupUI data={data} />;
};
